import React, { useMemo } from 'react'


import withObservables from '@nozbe/with-observables'
import moment from 'moment/moment'
import PropTypes from 'prop-types'

import filter from 'lodash/filter'
import isEmpty from 'lodash/isEmpty'
import toNumber from 'lodash/toNumber'

import { pricesDataService } from '@smartcoop/database/services/pricesDataService'
import { database } from '@smartcoop/database/web-database'
import { momentBackDateFormat, momentBackMonthYearFormat } from '@smartcoop/utils/dates'
import DataTable from '@smartcoop/web-components/DataTable'

const ListPriceDataFragment = ({ pricesData, milkDataLoading, filters, columns, onEditClick, disabledEdit, conditionToDelete, onDeleteClick, detailPanel }) => {

  const pricesDataList = useMemo(() => {
    const filtered = isEmpty(filters) ? pricesData : filter(pricesData, item => {
      if((!isEmpty(filters?.userStateRegistrationId) && filters?.userStateRegistrationId === item?.userStateRegistrationId) ||
      (!isEmpty(filters?.from) && moment(item?.priceDate, momentBackDateFormat).isBetween(moment(filter?.from, momentBackMonthYearFormat).startOf('month'), moment(filter?.toString, momentBackMonthYearFormat).endOf('month'))) ||
      (!isEmpty(filters?.initialPrice) && toNumber(item?.price) >= toNumber(filters?.initialPrice) && toNumber(item?.price) <= toNumber(filters?.finalPrice))
      ) {
        return item
      }
      return false
    })

    return filtered
  }, [filters, pricesData])

  return (
    <DataTable
      data={ pricesDataList }
      columns={ columns }
      onEditClick={ onEditClick }
      disabledEdit={ disabledEdit }
      conditionToDelete={ conditionToDelete }
      onDeleteClick={ onDeleteClick }
      detailPanel={ detailPanel }
      id="list-milk-quality-table"
      loading={ milkDataLoading }
    />
  )
}

ListPriceDataFragment.propTypes = {
  pricesData: PropTypes.array.isRequired,
  columns: PropTypes.object.isRequired,
  milkDataLoading: PropTypes.bool.isRequired,
  detailPanel: PropTypes.func.isRequired,
  onEditClick: PropTypes.func.isRequired,
  disabledEdit: PropTypes.func.isRequired,
  conditionToDelete: PropTypes.func.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  filters: PropTypes.object.isRequired
}

const enhance = withObservables(['dairyFarmId'], ({ dairyFarmId }) => ({
  pricesData: pricesDataService(database).observePricesData(dairyFarmId)
}))

const EnhancedListPriceDataFragment = enhance(ListPriceDataFragment)

export default EnhancedListPriceDataFragment